import { createRoot } from "react-dom/client";
import App, { preloadRoute } from "./App";
import "@fontsource-variable/space-grotesk/wght.css";
import "@fontsource/space-mono/latin-400.css";
import "@fontsource/space-mono/latin-700.css";
import "@fontsource/space-mono/latin-400-italic.css";
import "./index.css";

// Load the current page's chunk first so React replaces the prerendered HTML with the
// same page, not a loading spinner.
const base = import.meta.env.BASE_URL.replace(/\/$/, "");
const pathname = window.location.pathname.slice(base.length) || "/";
preloadRoute(pathname)
  .catch(() => undefined)
  .then(() => {
    createRoot(document.getElementById("root")!).render(<App />);
  });
